export const N77 = {
    "columns": 4,
    "rows": 1,
    "visual": {
        "id": 14,
        "type": "donut",
        "colorTheme": "colorTheme1",
        "title": "Share by Region",
        "binding": {
            "data": {
                "title": 'RegionCode',
                "value": 'Share',
                "tooltip": 'ActualSales',
                "currency": true,
                "percent": true,
                "endpoint": "N77",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": { }
                }
            }
        }
    }
}
